import { Organization } from "generated/graphql";
import { getString } from "utils/Utils";
import { SubmitAppEndAction } from "../../../App/modules/actions/SubmitApp";
import { OrgState } from "../state";
import { updateAccountSummary } from "./FetchPaymentAccontSummary";
import { updateOrganization } from "./UpdateOrganization";

export function submitApp(state: OrgState, action: SubmitAppEndAction) {
    const { error, result } = action.payload;
    const { accountSummary, organization } = result ? result : { accountSummary: undefined, organization: undefined };
    const organizationId = getString(organization, "organizationId");
    let updatedState: OrgState = state;
    if (organizationId) {
        updatedState = updateAccountSummary(state, { payload: { organizationId, error, accountSummary } });
    }

    return updateOrganization(updatedState, { payload: { error, organization: organization as Organization } });
}
